import React, { useCallback, useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Tiles, Table, Tabs, Chip, fmt, when } from "./kit";
import kopyalaPano from "../../util/kopyala";

const small = { fontSize: 12, color: "#6B7280" };
const cell = { width: "100%", padding: "5px 8px", border: "1px solid #E5E7EB", borderRadius: 6, fontSize: 13 };
const statusChip = (s) =>
  ({
    paid: <Chip>Ödendi · coin yüklendi</Chip>,
    created: <Chip kind="wait">Ödeme sayfasında</Chip>,
    expired: <Chip kind="bad">Vazgeçti</Chip>,
    refunded: <Chip kind="bad">İade edildi</Chip>,
  }[s] || s);

const WebSite = () => {
  const [tab, setTab] = useState("settings");
  const [site, setSite] = useState(null);
  const [stripe, setStripe] = useState(null);
  const [keys, setKeys] = useState({ secretKey: "", webhookSecret: "" });
  const [saving, setSaving] = useState("");
  const [msg, setMsg] = useState("");
  const [orders, setOrders] = useState({ orders: [], totals: { usd: 0, coins: 0, n: 0 } });
  const [f, setF] = useState({ status: "", code: "" });
  const [loading, setLoading] = useState(false);

  const flash = (m) => {
    setMsg(m);
    setTimeout(() => setMsg(""), 4000);
  };

  const load = useCallback(async () => {
    const r = await api.webGet();
    if (r?.status) {
      setSite(r.site);
      setStripe(r.stripe);
    }
  }, []);

  const loadOrders = useCallback(async () => {
    setLoading(true);
    const r = await api.webOrders(f);
    if (r?.status) setOrders(r);
    setLoading(false);
  }, [f]);

  useEffect(() => {
    load();
  }, [load]);
  useEffect(() => {
    if (tab === "orders") loadOrders();
  }, [tab, loadOrders]);

  const saveSite = async (next = site) => {
    setSaving("site");
    const r = await api.webSaveSite(next);
    setSaving("");
    if (!r?.status) return window.alert(r?.message || "Kaydedilemedi");
    setSite(r.site);
    flash("Kaydedildi");
  };

  const saveKeys = async () => {
    if (!keys.secretKey && !keys.webhookSecret) return window.alert("Değiştirmek istediğin anahtarı yaz.");
    setSaving("stripe");
    const r = await api.webSaveStripe(keys);
    setSaving("");
    if (!r?.status) return window.alert(r?.message || "Kaydedilemedi");
    setStripe(r.stripe);
    setKeys({ secretKey: "", webhookSecret: "" });
    flash("Stripe anahtarları kaydedildi");
  };

  const toggle = async () => {
    if (!site.enabled && !stripe?.hasSecretKey) return window.alert("Önce Stripe gizli anahtarını kaydet.");
    const text = site.enabled ? "Web sitesinde coin satışı kapatılsın mı?" : "Web sitesinde coin satışı açılsın mı? Kullanıcılar ID ile kartla coin alabilir.";
    if (!window.confirm(text)) return;
    await saveSite({ ...site, enabled: !site.enabled });
  };

  const setPkg = (i, key, value) => setSite({ ...site, packages: site.packages.map((p, j) => (j === i ? { ...p, [key]: value } : p)) });
  const setPopular = (i) => setSite({ ...site, packages: site.packages.map((p, j) => ({ ...p, popular: j === i ? !p.popular : false })) });
  const addPkg = () =>
    setSite({ ...site, packages: [...site.packages, { id: `w${Date.now()}`, usd: 10, coins: 70000, bonus: 0, popular: false, active: true }] });
  const removePkg = (i) => {
    if (!window.confirm("Paket silinsin mi?")) return;
    setSite({ ...site, packages: site.packages.filter((_, j) => j !== i) });
  };

  if (!site || !stripe) return <PageHead title="Web Sitesi" sub="Yükleniyor…" />;

  const ready = site.enabled && stripe.hasSecretKey;

  return (
    <>
      <PageHead
        title="Web Sitesi"
        sub="badulive.online — tanıtım, uygulama linkleri ve AYVO ID ile Stripe üzerinden coin satışı."
        right={
          <div className="d-flex align-items-center" style={{ gap: 10 }}>
            {msg && <span style={{ fontSize: 13, color: "#059669" }}>{msg}</span>}
            <a className="btn btn-outline-secondary" href={site.siteUrl || "https://badulive.online"} target="_blank" rel="noreferrer">
              Siteyi aç
            </a>
            {ready ? <Chip>Coin satışı açık</Chip> : <Chip kind="wait">Coin satışı kapalı</Chip>}
            <button className={`btn ${site.enabled ? "btn-outline-danger" : "btn-success"}`} onClick={toggle} disabled={saving === "site"}>
              {site.enabled ? "Kapat" : "Aç"}
            </button>
          </div>
        }
      />

      <Tabs
        tabs={[
          ["settings", "Ayarlar ve paketler"],
          ["stripe", "Stripe"],
          ["orders", "Siparişler"],
        ]}
        value={tab}
        onChange={setTab}
      />

      {tab === "settings" && (
        <>
          <div className="card mb-3">
            <div className="card-body">
              <b>Uygulama linkleri</b>
              <div style={{ ...small, marginBottom: 10 }}>Boş bırakılırsa sitede butonun üstünde “Yakında” yazar. Mağaza sayfasının tam linkini yapıştır.</div>
              <div className="row">
                <div className="col-md-4 mb-2">
                  <div style={small}>App Store linki</div>
                  <input className="form-control" placeholder="https://apps.apple.com/app/id..." value={site.appStoreUrl} onChange={(e) => setSite({ ...site, appStoreUrl: e.target.value })} />
                </div>
                <div className="col-md-4 mb-2">
                  <div style={small}>Google Play linki</div>
                  <input className="form-control" placeholder="https://play.google.com/store/apps/details?id=com.badu.live" value={site.playStoreUrl} onChange={(e) => setSite({ ...site, playStoreUrl: e.target.value })} />
                </div>
                <div className="col-md-4 mb-2">
                  <div style={small}>Site adresi (ödeme sonrası dönüş)</div>
                  <input className="form-control" value={site.siteUrl} onChange={(e) => setSite({ ...site, siteUrl: e.target.value })} />
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body" style={{ overflowX: "auto" }}>
              <b>Coin paketleri</b>
              <div style={{ ...small, marginBottom: 10 }}>
                Uygulama içi fiyat 1 $ = 5.500 coin. Web'de Apple kesintisi olmadığı için daha fazla coin verilebilir (öneri 1 $ = 7.000). Bonus, pakete ek coin olarak eklenir.
              </div>
              <table className="table table-sm mb-2" style={{ minWidth: 720 }}>
                <thead>
                  <tr style={{ fontSize: 12, color: "#6B7280" }}>
                    <th>Fiyat ($)</th>
                    <th>Coin</th>
                    <th>Bonus coin</th>
                    <th>1 $ başına</th>
                    <th>En çok alınan</th>
                    <th>Satışta</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {site.packages.map((p, i) => {
                    const per = Number(p.usd) > 0 ? Math.round((Number(p.coins) + Number(p.bonus || 0)) / Number(p.usd)) : 0;
                    return (
                      <tr key={p.id}>
                        <td>
                          <input style={cell} type="number" value={p.usd} onChange={(e) => setPkg(i, "usd", e.target.value)} />
                        </td>
                        <td>
                          <input style={cell} type="number" value={p.coins} onChange={(e) => setPkg(i, "coins", e.target.value)} />
                        </td>
                        <td>
                          <input style={cell} type="number" value={p.bonus || 0} onChange={(e) => setPkg(i, "bonus", e.target.value)} />
                        </td>
                        <td style={{ verticalAlign: "middle" }}>{fmt(per)}</td>
                        <td style={{ verticalAlign: "middle" }}>
                          <input type="checkbox" checked={p.popular === true} onChange={() => setPopular(i)} />
                        </td>
                        <td style={{ verticalAlign: "middle" }}>
                          <input type="checkbox" checked={p.active !== false} onChange={(e) => setPkg(i, "active", e.target.checked)} />
                        </td>
                        <td style={{ verticalAlign: "middle" }}>
                          <button className="btn btn-sm btn-outline-danger" onClick={() => removePkg(i)}>
                            Sil
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div className="d-flex align-items-center" style={{ gap: 8 }}>
                <button className="btn btn-sm btn-outline-secondary" onClick={addPkg} disabled={site.packages.length >= 12}>
                  Paket ekle
                </button>
                <button className="btn btn-primary ml-auto" disabled={saving === "site"} onClick={() => saveSite()}>
                  {saving === "site" ? "Kaydediliyor…" : "Kaydet"}
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {tab === "stripe" && (
        <div className="card">
          <div className="card-body">
            <div className="d-flex flex-wrap mb-3" style={{ gap: 10 }}>
              {stripe.hasSecretKey ? <Chip>Gizli anahtar kayıtlı: {stripe.secretKeyHint}</Chip> : <Chip kind="bad">Gizli anahtar yok</Chip>}
              {stripe.hasSecretKey && (stripe.live ? <Chip>Canlı mod</Chip> : <Chip kind="wait">Test modu (gerçek para çekilmez)</Chip>)}
              {stripe.hasWebhookSecret ? <Chip>Webhook anahtarı kayıtlı</Chip> : <Chip kind="wait">Webhook anahtarı yok</Chip>}
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <div style={small}>Gizli anahtar (Secret key)</div>
                <input
                  className="form-control"
                  type="password"
                  autoComplete="off"
                  placeholder={stripe.hasSecretKey ? "Değiştirmek için yeni anahtarı yapıştır" : "sk_live_..."}
                  value={keys.secretKey}
                  onChange={(e) => setKeys({ ...keys, secretKey: e.target.value.trim() })}
                />
                <div style={small} className="mt-1">
                  Stripe Dashboard → Developers → API keys → Secret key. Kaydedince Stripe'a sorulup doğrulanır; kaydedilen anahtar bir daha gösterilmez.
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div style={small}>Webhook imza anahtarı (Signing secret)</div>
                <input
                  className="form-control"
                  type="password"
                  autoComplete="off"
                  placeholder={stripe.hasWebhookSecret ? "Değiştirmek için yeni anahtarı yapıştır" : "whsec_..."}
                  value={keys.webhookSecret}
                  onChange={(e) => setKeys({ ...keys, webhookSecret: e.target.value.trim() })}
                />
                <div style={small} className="mt-1">İsteğe bağlı ama önerilir: tarayıcı kapansa bile ödeme anında coin yüklenir.</div>
              </div>
            </div>
            <button className="btn btn-primary" disabled={saving === "stripe"} onClick={saveKeys}>
              {saving === "stripe" ? "Doğrulanıyor…" : "Anahtarları kaydet"}
            </button>

            <hr />
            <b>Webhook kurulumu (bir kez)</b>
            <ol style={{ fontSize: 13, color: "#374151", paddingLeft: 18, marginTop: 8 }}>
              <li>Stripe Dashboard → Developers → Webhooks → “Add endpoint”.</li>
              <li>
                Endpoint URL: <code>{stripe.webhookUrl}</code>{" "}
                <button className="btn btn-sm btn-link p-0" onClick={() => kopyalaPano(stripe.webhookUrl).then((ok) => flash(ok ? "Kopyalandı" : "Kopyalanamadı"))}>
                  kopyala
                </button>
              </li>
              <li>
                Olaylar: <code>checkout.session.completed</code>, <code>checkout.session.async_payment_succeeded</code>, <code>checkout.session.expired</code>, <code>charge.refunded</code>
              </li>
              <li>Oluşan “Signing secret” (whsec_…) değerini yukarıdaki kutuya yapıştırıp kaydet.</li>
            </ol>
          </div>
        </div>
      )}

      {tab === "orders" && (
        <>
          <Tiles
            items={[
              { label: "Ödenen sipariş", value: fmt(orders.totals.n) },
              { label: "Toplam satış", value: `${(orders.totals.usd || 0).toLocaleString("tr-TR")} $` },
              { label: "Yüklenen coin", value: fmt(orders.totals.coins) },
            ]}
          />
          <div className="card">
            <div className="card-body d-flex flex-wrap align-items-end" style={{ gap: 10 }}>
              <div>
                <div style={small}>Durum</div>
                <select className="form-control" value={f.status} onChange={(e) => setF({ ...f, status: e.target.value })}>
                  <option value="">Tümü</option>
                  <option value="paid">Ödendi</option>
                  <option value="created">Ödeme sayfasında</option>
                  <option value="expired">Vazgeçti</option>
                  <option value="refunded">İade</option>
                </select>
              </div>
              <div>
                <div style={small}>AYVO ID</div>
                <input className="form-control" value={f.code} onChange={(e) => setF({ ...f, code: e.target.value })} placeholder="ör. 2568689" />
              </div>
            </div>
          </div>
          <Table
            loading={loading}
            empty="Henüz sipariş yok."
            head={["Tarih", "Kullanıcı", "ID", "Tutar", "Coin", "Durum", "E-posta / ülke"]}
            rows={orders.orders.map((o) => (
              <tr key={o._id}>
                <td>{when(o.createdAt)}</td>
                <td>{o.name}</td>
                <td>
                  <code>{o.uniqueID}</code>
                </td>
                <td>
                  <b>{o.usd} $</b>
                </td>
                <td>{fmt(o.coins)}</td>
                <td>{statusChip(o.status)}</td>
                <td style={{ fontSize: 12 }}>
                  {o.email}
                  {o.country ? ` · ${o.country}` : ""}
                </td>
              </tr>
            ))}
          />
        </>
      )}
    </>
  );
};

export default WebSite;
